import { useTranslation } from 'react-i18next';
import type { UseFormReturn } from 'react-hook-form';
import { Input } from '@/shared/ui/inputs/Input';
import { Section } from '@/shared/ui/layout/Section';
import { handleUppercaseChange } from '@/shared/lib/forms';
import type { ParcelFormValues } from '@/features/parcel-form/modules/types';

type Props = {
  form: UseFormReturn<ParcelFormValues>;
};

// Trek ID owner spec: 5–255 chars, latin/digits/hyphen, always uppercase. We
// transform on every keystroke so the displayed value, the form state, and the
// zod-validated payload all stay aligned with the regex.
const TREK_ID_MAX = 255;

export const FeaturesParcelFormSectionBasic = ({ form }: Props) => {
  const { t } = useTranslation('parcelForm');
  const { register, formState } = form;
  const errors = formState.errors;
  const trekIdField = register('trek_id');
  return (
    <Section title={t('sectionBasic')}>
      <Input
        label={t('fields.name')}
        required
        placeholder={t('fields.namePlaceholder')}
        error={errors.name?.message ? t(errors.name.message) : undefined}
        {...register('name')}
      />
      <Input
        label={t('fields.trekId')}
        required
        placeholder={t('fields.trekIdPlaceholder')}
        error={errors.trek_id?.message ? t(errors.trek_id.message) : undefined}
        autoCapitalize="characters"
        maxLength={TREK_ID_MAX}
        {...trekIdField}
        onChange={handleUppercaseChange(trekIdField.onChange)}
      />
      <Input
        label={t('fields.storeName')}
        placeholder={t('fields.storeNamePlaceholder')}
        error={errors.store_name?.message ? t(errors.store_name.message) : undefined}
        {...register('store_name')}
      />
    </Section>
  );
};
